// import GlobeObject from './components/GlobeObject.vue';
import ZoomButtons from './components/ZoomButtons.vue';
import RiskKey from './components/RiskKey.vue';
import GlobeFootBar from './components/GlobeFootBar.vue';
import DownloadPdfButton from './components/DownloadPdfButton.vue';

//Information Components
import MoreInfoHolder from './components/Information/MoreInfoHolder.vue';
import InformationSelectMenu from './components/Information/InformationSelectMenu.vue';
import CountryNameBar from './components/Information/CountryNameBar.vue';
import InformationSelectFooter from './components/Information/InformationSelectFooter.vue';

//Risk Components
import RiskInformation from './components/Risk/RiskInformation.vue';

// Key Figures Components
import KeyFigures from './components/KeyFigures/KeyFigures.vue';

// ESG
import ESGView from './components/ESG/ESG.vue';

//Search
import SearchButton from './components/Search/SearchButton.vue';
import SearchWidget from './components/Search/SearchWidget.vue';

//Movement Focus
import MovementFocusButton from './components/MovementFocus/MovementFocusButton.vue';
import MovementFocus from './components/MovementFocus/MovementFocus.vue';
import ExploreButton from './components/MovementFocus/ExploreButton.vue';
import MovementWidget from './components/MovementFocus/MovementWidget.vue';

//Industry Performance
import IndustryPerformance from './components/IndustryPerformance/IndustryPerformance.vue';
import IndustryPerformanceScores from './components/IndustryPerformance/IndustryPerformanceScores.vue';
import CompareCountriesButton from './components/IndustryPerformance/CompareCountriesButton.vue';
import CountryPicker from './components/IndustryPerformance/CountryPicker.vue';


export default{
    // GlobeObject,
    ZoomButtons,
    RiskKey,
    GlobeFootBar,
    DownloadPdfButton,

    //Information Components
    MoreInfoHolder,
    InformationSelectMenu,
    CountryNameBar,
    InformationSelectFooter,

    //Risk Components
    RiskInformation,

    // ESG
    ESGView,

    // Key Figures Components
    KeyFigures,

    //Search
    SearchButton,
    SearchWidget,

    //Movement Focus
    MovementFocusButton,
    MovementFocus,
    ExploreButton,
    MovementWidget,

    //Industry Performance
    IndustryPerformance,
    IndustryPerformanceScores,
    CompareCountriesButton,
    CountryPicker
}